// extracted by css-extract-rspack-plugin
export default {"root":"root__oSi","inner":"inner_mu0L","links":"links_U5Eo","link":"link_3SQ1","version":"version_atSO"};